import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.jpg';

interface NavigationProps {
  showHamburger?: boolean;
}

export default function Navigation({ showHamburger = true }: NavigationProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handlePriceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // 他のページからの場合は直接URLで遷移
      window.location.href = '/#price';
    } else {
      const priceSection = document.getElementById('price');
      if (priceSection) {
        const navHeight = 64; // ナビゲーションの高さ (h-16 = 64px)
        const elementPosition = priceSection.offsetTop - navHeight;
        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
      }
    }
  };

  const handleAccessClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // 他のページからの場合は直接URLで遷移
      window.location.href = '/#access';
    } else {
      const accessSection = document.getElementById('access');
      if (accessSection) {
        const navHeight = 64; // ナビゲーションの高さ (h-16 = 64px)
        const elementPosition = accessSection.offsetTop - navHeight;
        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
      }
    }
  };

  const handleReserveClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('https://re.asmobi.jp/9_hair_salon/', '_blank');
  };

  const menuItems = [
    { path: '/', label: 'Home', isLink: true },
    { path: '#price', label: 'Price', isLink: false, onClick: handlePriceClick },
    { path: '/staff', label: 'Staff', isLink: true },
    { path: '/news', label: 'News', isLink: true },
    { path: '#access', label: 'Access', isLink: false, onClick: handleAccessClick },
    { path: '/reserve', label: 'Reserve', isLink: false, onClick: handleReserveClick },
  ];

  return (
    <nav className="bg-white border-b border-black w-full fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="font-bold text-black">
            <img src={logo} alt='草加の美容室「9（ナイン)」' width="306px" height="345px" loading="eager" decoding="async" draggable="false" className="block h-8 md:h-9 w-auto" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              item.isLink ? (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`font-medium transition-colors hover:text-gray-600 cursor-pointer whitespace-nowrap flex items-center h-16 ${
                    location.pathname === item.path ? 'text-black border-b-2 border-black' : 'text-gray-800'
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.path}
                  onClick={item.onClick}
                  className="font-medium text-gray-800 transition-colors hover:text-gray-600 cursor-pointer whitespace-nowrap flex items-center h-16"
                >
                  {item.label}
                </button>
              )
            ))}
          </div>

          {/* Mobile Hamburger Menu */}
          {showHamburger && (
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-black hover:text-gray-600 focus:outline-none cursor-pointer"
              >
                <div className="w-6 h-6 flex flex-col items-center justify-center">
                  <span className={`w-5 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : 'mb-1'}`}></span>
                  <span className={`w-5 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'opacity-0' : 'mb-1'}`}></span>
                  <span className={`w-5 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
                </div>
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        {showHamburger && isMenuOpen && (
          <div className="md:hidden border-t border-black bg-white">
            <div className="py-4 space-y-4">
              {menuItems.map((item) => (
                item.isLink ? (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`block font-medium transition-colors hover:text-gray-600 cursor-pointer whitespace-nowrap ${
                      location.pathname === item.path ? 'text-black font-bold' : 'text-gray-800'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <button
                    key={item.path}
                    onClick={(e) => {
                      item.onClick?.(e);
                      setIsMenuOpen(false);
                    }}
                    className="block font-medium text-gray-800 transition-colors hover:text-gray-600 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                )
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
